import { notification } from 'antd';

import { Credit, User } from '../../api/go';
import { atom } from 'nanostores';
import { OSInfoLog } from '../../api/type';

export interface LogItem {
  Id: number;
  UserId: string;
  BeforeScore: number;
  AfterScore: number;
  DeductScore: number;
  Reason: string;
  RelatedId: number;
  Remark: string;
  Type: string;
  CreatedAt: string;
}

export type FieldType = {
  user_id?: string;
  user_nick?: string;
};

export interface EditForm {
  score: number;
  reason: string;
  remark: string;
}

export interface BanForm {
  score: number;
  reason: string;
  remark: string;
  banEnd: any;
}

export interface UserInfo {
  UserId: string;
  NickName: string;
  Status: number;
  DisableRemark: string;
}

export const DefaultData = {
  loading: false,
  info: {} as UserInfo,
  tips: '',
  current: -1,
  list: [] as Array<LogItem>,
  actionList: [] as Array<any>,
  deviceLogs: [] as Array<OSInfoLog>,
};

export const store = atom(DefaultData);

export async function loadList(query: FieldType) {
  try {
    store.set({ ...store.get(), loading: true });

    const _userId = query.user_id || '';
    const _userNick = _userId === '' ? query.user_nick || '' : '';
    const info = await User.info(_userId, _userNick);

    const resp = await Credit.fetchList(query);

    const userId = info.UserId;

    const actionList = await Credit.actionList({ user_id: userId });

    const current = await Credit.current(userId);
    const tipsList = await Credit.tips(userId);
    let tips = '';
    if (tipsList && tipsList.length) {
      tips = tipsList[0].tips;
    }

    // 加载历史设备信息
    const deviceLogs = await User.OSInfoLog(userId);

    store.set({ loading: false, list: resp.data, current, tips, actionList: actionList.records, info, deviceLogs });
  } catch (error) {
    notification.error({
      message: '加载失败-未知原因',
      description: '获取用户信用分信息失败，请稍后重试',
    });

    store.set(DefaultData);
  }
}

export async function updateCredit(params: EditForm) {
  const state = store.get();

  const userId = state.info.UserId;

  await Credit.update({
    ...params,
    user_id: userId,
  });

  return loadList({ user_id: userId });
}

// 带玩家可见日志修改信誉分
export async function updateCreditWithLog(params: EditForm) {
  const state = store.get();

  const userId = state.info.UserId;

  await Credit.updateEx({
    ...params,
    user_id: userId,
    score: parseInt(params.score as any, 10),
  });

  return loadList({ user_id: userId });
}

export function clearState() {
  store.set(DefaultData);
}
